import React from 'react';

import ChevronLeft from '@/assets/icon-chevron-left.svg?react';
import { scrollRootToTop } from '@/core/utils/ui';

import classes from './styles.module.scss';

type Theme =
  | 'primary'
  | 'textOnPrimary'
  | 'outlineOnPrimary'
  | 'outlineOnBackground'
  | 'primaryOnWhite'
  | 'blackOnWhite';
type Size = 'small' | 'medium' | 'large';
type ChevronType = 'left' | 'right';

interface Props extends React.HTMLAttributes<HTMLElement> {
    onclick?: () => void;
    extClasses?: string;
    type: Theme;
    size: Size;
    children: React.ReactNode;
    id?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
    testId?: string;
    chevron?: ChevronType;
    disableScroll?: boolean;
    'data-i18n-key'?: string;
    // Forwarded for Automate's inspector, like data-i18n-key: the
    // rs-setting-data-attr build plugin stamps it and settingsTextMarker resolves
    // it. Without forwarding it never reaches the DOM <button>.
    'data-rs-setting-dynamic'?: string;
}

export default function Button({
    children,
    style,
    onclick,
    extClasses,
    id,
    type,
    size,
    disabled,
    testId,
    chevron,
    disableScroll,
    'data-i18n-key': dataI18nKey,
    'data-rs-setting-dynamic': dataRsSettingDynamic,
}: Props) {
    return (
        // eslint-disable-next-line react/button-has-type
        <button
            id={id}
            style={style}
            // eslint-disable-next-line jsx-a11y/aria-role
            role="ui-button"
            disabled={disabled}
            className={`${classes[type]} ${classes[size]} ${extClasses} ${
                chevron === 'left' && classes.chevronLeft
            }`}
            onClick={() => {
                if (onclick) {
                    onclick();
                }
                if (!disableScroll) {
                    scrollRootToTop();
                }
            }}
            data-testid={testId}
            data-i18n-key={dataI18nKey}
            data-rs-setting-dynamic={dataRsSettingDynamic}
        >
            {chevron === 'left' && <ChevronLeft />}
            {children}
        </button>
    );
}
